var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage painted-finger-clue"
  }, [_c('figure', {
    key: _vm.currentKey,
    staticClass: "keyboard-k2 painted-finger-clue-keys",
    style: {
      'margin-left': _vm.marginLeftCurrentKey
    }
  }, [_c('div', {
    class: _vm.currentKey,
    style: {
      backgroundColor: _vm.currentKeyColor
    }
  })]), _vm.progress ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBothHands || _vm.holdKeyPressed,
      expression: "showBothHands || holdKeyPressed"
    }],
    staticClass: "painted-finger-clue-container",
    class: !_vm.showBothHands ? 'painted-one-hand' : ''
  }, [_vm.isVisibleLeftHand ? _c('div', {
    staticClass: "painted-finger-clue-left-side"
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.leftHand.svg)
    }
  })])]) : _vm._e(), _vm.isVisibleRightHand ? _c('div', {
    staticClass: "painted-finger-clue-right-side"
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.rightHand.svg)
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }